import React, { useState } from 'react'
import { Loading } from '@workwhile/ui'
import { createContext } from 'lib/createContext'
import { useDayforceJobQuery } from 'queries/admin/dayforce/useDayforceJobQuery'
import { useDayforceJobContextValue } from 'pages/Shifts/ShiftDetail/context/DayforceJobProvider'

type DayforcePanelContextState = {
  state: {
    job: ReturnType<typeof useDayforceJobContextValue>['state']['job']
    booking: ReturnType<typeof useDayforceJobContextValue>['state']['booking']
    isPending: boolean
    isError: boolean
    error: ReturnType<typeof useDayforceJobQuery>['error'] | null
    isDayforceJobDetailsModalOpen: boolean
  }
  actions: {
    toggleDayforceJobDetailsModal: () => void
  }
}

const [Context, useDayforcePanelContextValue] =
  createContext<DayforcePanelContextState>({
    name: 'DayforcePanelContext',
  })

export const DayforcePanelProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const {
    state: { job, booking, isPending, isError, error },
  } = useDayforceJobContextValue()

  const [isDayforceJobDetailsModalOpen, setIsDayforceJobDetailsModalOpen] =
    useState(false)

  if (isPending) {
    return <Loading />
  }

  const value = {
    state: {
      job,
      booking,
      isPending,
      isError,
      error: error ?? null,
      isDayforceJobDetailsModalOpen,
    },
    actions: {
      toggleDayforceJobDetailsModal: () => {
        setIsDayforceJobDetailsModalOpen(!isDayforceJobDetailsModalOpen)
      },
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useDayforcePanelContextValue }
